module.exports = __webpack_public_path__ + "media/customizations/tehaleh/back-b469f0247a78141d85d4287b3e71be04.jpg";